import React from "react";

// reactstrap components
import {
  Alert,
  Button,
  Card,
  CardHeader,
  Col,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  CardBody,
} from "reactstrap";
// core components
import Header from "components/Headers/UserHeader";
import ShoppingRules from "components/Tables/ShoppingRules";
import CreditDataService from "../../services/CreditDataService";
import SettingDataService from "../../services/SettingDataService";
import ProductDataService from "../../services/ProductDataService";
import WarehouseDataService from "../../services/WarehouseDataService";

const EMPTY_RULE = {
  product_id: undefined,
  product_name: "",
  warehouse_id: -1,
  price_limitation: "",
  stock_limitation: "",
};

const EMPTY_DRAFT = {
  price_limitation: "",
  stock_limitation: "",
};

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      success: false,
      successSettings: false,
      successLoyaltySettings: false,
      successShoppingRules: false,
      maxCredit: 0,
      minProductStock: {},
      pointsPerStar: {},
      amountPerPoint: {},
      warehouses: [],
      shoppingRules: [],
      newRule: { ...EMPTY_RULE },
      productKeyword: "",
      productResults: [],
      productSearchType: "nama",
      editingIndex: null,
      editingDraft: { ...EMPTY_DRAFT },
    };
    this.creditDataService = new CreditDataService();
    this.settingDataService = new SettingDataService();
    this.productDataService = new ProductDataService();
    this.warehouseDataService = new WarehouseDataService();
  }

  componentDidMount() {
    this.fetchData()
  }

  onKeyUp(e) {
    delete this.state.errorMessage;
    var charCode = (typeof e.which === "undefined") ? e.keyCode : e.which;
    if (charCode === 13) {
      this.handleSaveMaxCredit();
    }
}

  fetchData() {
    this.creditDataService
      .getMaxCredit()
      .then(res => {
        let maxCredit = res.data !== null ? res.data : 0;
        maxCredit = Number(maxCredit).toLocaleString();;

        this.setState({
          maxCredit
        })
      });

    this.warehouseDataService
      .getList(1, 99999, null)
      .then((data) => {
        const warehouses = data.data?.warehouse_list !== null && data.data?.errorMessage === undefined
          ? data.data.warehouse_list
          : [];
        this.setState({ warehouses });
      });

    this.settingDataService
      .getList()
      .then(res => {
        let amountPerPoint = res.data?.filter(setting => setting.key === 'amount_per_point')[0];
        if (amountPerPoint?.value !== undefined) {
          amountPerPoint = { ...amountPerPoint, value: Number(amountPerPoint.value).toLocaleString() };
        }

        this.setState({
          minProductStock: res.data?.filter(setting => setting.key === 'min_product_stock')[0],
          pointsPerStar: res.data?.filter(setting => setting.key === 'points_per_star')[0],
          amountPerPoint,
        });

        const shoppingRulesSetting = res.data
          ?.filter(setting => setting.key === 'shopping_rules')
          .reduce((latest, setting) => (!latest || setting.id > latest.id) ? setting : latest, undefined);
        this.loadShoppingRules(shoppingRulesSetting?.value);
      })
  }

  loadShoppingRules(rawValue) {
    let rules = [];
    if (rawValue) {
      try {
        const parsed = typeof rawValue === 'string' ? JSON.parse(rawValue) : rawValue;
        if (Array.isArray(parsed)) {
          rules = parsed;
        }
      } catch (e) {
        rules = [];
      }
    }

    if (rules.length === 0) {
      this.setState({ shoppingRules: [] });
      return;
    }

    const uniqueProductIds = [...new Set(rules.map(rule => rule.product_id))];
    Promise.all(uniqueProductIds.map(productId => this.productDataService.getById(productId)))
      .then(results => {
        const productNameById = {};
        results.forEach(result => {
          if (result.product) {
            productNameById[result.product.product_id] = result.product.product_name;
          }
        });

        this.setState({
          shoppingRules: rules.map(rule => ({
            ...rule,
            product_name: productNameById[rule.product_id],
          })),
        });
      });
  }

  handleInputChanged(e) {
    let nam = e.target.name
    let val = e.target.value
    let updateState = true;
    if (nam === 'amountPerPoint') {
      if (val.length > 21) {
        this.setErrormessage('Input angka melebihi batas maksimal sistem.')
        setTimeout(() => {
            this.setState({ errorMessage: undefined });
        }, 5000);
      } else {
        val = val.replace(/,/g, '');
        val = Number(val).toLocaleString();
        this.setState(prevState => {
          return {
            amountPerPoint: {
              ...prevState.amountPerPoint,
              value: val
            }}});
      }
      updateState = false;
    } else if (['minProductStock', 'pointsPerStar'].includes(nam)) {
      this.setState(prevState => {
        return {
          [nam]: {
            ...prevState[nam],
            value: val
          }}});
      updateState = false;
    } else if (val.length > 21) {
        this.setErrormessage('Input angka melebihi batas maksimal sistem.')
        setTimeout(() => {
            this.setState({ errorMessage: undefined });
        }, 5000);
        updateState = false;
    } else {
        val = val.replace(/,/g, '');
        val = Number(val).toLocaleString();
    }

    if (updateState) {
      this.setState({
        [nam]: val,
      })
    }
  }

  handleSaveMaxCredit() {
      this.creditDataService.updateMaxCredit({ max_kredit: Number(this.state.maxCredit.replace(/,/g, '')) })
        .then(() => { this.setState({ success: true })})
  }

  handleSaveSetting() {
      this.settingDataService.add(this.state.minProductStock)
        .then(() => { this.setState({ successSettings: true })})
  }

  handleSaveLoyaltySetting() {
      Promise.all([
        this.settingDataService.add({ ...this.state.pointsPerStar, key: 'points_per_star' }),
        this.settingDataService.add({
          ...this.state.amountPerPoint,
          key: 'amount_per_point',
          value: Number(String(this.state.amountPerPoint?.value ?? '0').replace(/,/g, '')),
        }),
      ]).then(() => { this.setState({ successLoyaltySettings: true })})
  }

  handleProductKeywordChanged(e) {
    const keyword = e.target.value;
    this.setState({
      productKeyword: keyword,
      newRule: { ...this.state.newRule, product_id: undefined, product_name: '' },
    });

    this.searchProducts(keyword, this.state.productSearchType);
  }

  handleProductSearchTypeChanged(e) {
    const productSearchType = e.target.value;
    this.setState({ productSearchType });
    this.searchProducts(this.state.productKeyword, productSearchType);
  }

  searchProducts(keyword, searchType) {
    if (!keyword) {
      this.setState({ productResults: [] });
      return;
    }

    const search = searchType === 'barcode'
      ? this.productDataService.getByBarcode(keyword, 1, 8)
      : this.productDataService.getList(keyword, undefined, 1, 8, 0, false);

    search.then(res => this.setState({ productResults: res.products || [] }));
  }

  handleSelectProduct(product) {
    this.setState({
      newRule: { ...this.state.newRule, product_id: product.product_id, product_name: product.product_name },
      productKeyword: product.product_name,
      productResults: [],
    });
  }

  handleNewRuleChanged(e) {
    let { name, value } = e.target;

    if (name === 'warehouse_id') {
      value = Number(value);
    } else if (name === 'price_limitation') {
      value = value.replace(/,/g, '');
      if (!/^\d*$/.test(value)) return;
      value = value === '' ? '' : Number(value).toLocaleString();
    } else if (name === 'stock_limitation') {
      if (!/^\d*$/.test(value)) return;
    }

    this.setState(prevState => ({ newRule: { ...prevState.newRule, [name]: value } }));
  }

  handleAddRule() {
    const { newRule, shoppingRules } = this.state;

    if (!newRule.product_id) {
      this.setRuleError('Pilih produk terlebih dahulu.');
      return;
    }
    if (!newRule.warehouse_id || newRule.warehouse_id === -1) {
      this.setRuleError('Pilih warehouse terlebih dahulu.');
      return;
    }
    if (shoppingRules.some(rule => rule.product_id === newRule.product_id && rule.warehouse_id === newRule.warehouse_id)) {
      this.setRuleError('Produk dan warehouse ini sudah ada di daftar.');
      return;
    }

    const rule = {
      product_id: newRule.product_id,
      product_name: newRule.product_name,
      warehouse_id: newRule.warehouse_id,
      price_limitation: Number(String(newRule.price_limitation || '0').replace(/,/g, '')),
      stock_limitation: Number(newRule.stock_limitation || 0),
    };

    this.setState({
      shoppingRules: [...shoppingRules, rule],
      newRule: { ...EMPTY_RULE },
      productKeyword: '',
      productResults: [],
      ruleErrorMessage: undefined,
    });
  }

  setRuleError(message) {
    this.setState({ ruleErrorMessage: message });
    setTimeout(() => {
      this.setState({ ruleErrorMessage: undefined });
    }, 5000);
  }

  handleRemoveRule(index) {
    this.setState(prevState => ({
      shoppingRules: prevState.shoppingRules.filter((_, i) => i !== index),
    }));
  }

  handleStartEditRule(index) {
    const rule = this.state.shoppingRules[index];
    this.setState({
      editingIndex: index,
      editingDraft: {
        price_limitation: rule.price_limitation > 0 ? Number(rule.price_limitation).toLocaleString() : '',
        stock_limitation: rule.stock_limitation > 0 ? String(rule.stock_limitation) : '',
      },
    });
  }

  handleEditRuleChanged(e) {
    let { name, value } = e.target;

    if (name === 'price_limitation') {
      value = value.replace(/,/g, '');
      if (!/^\d*$/.test(value)) return;
      value = value === '' ? '' : Number(value).toLocaleString();
    } else if (name === 'stock_limitation') {
      if (!/^\d*$/.test(value)) return;
    }

    this.setState(prevState => ({ editingDraft: { ...prevState.editingDraft, [name]: value } }));
  }

  handleSaveEditRule(index) {
    const { editingDraft } = this.state;
    this.setState(prevState => ({
      shoppingRules: prevState.shoppingRules.map((rule, i) => i === index ? {
        ...rule,
        price_limitation: Number(String(editingDraft.price_limitation || '0').replace(/,/g, '')),
        stock_limitation: Number(editingDraft.stock_limitation || 0),
      } : rule),
      editingIndex: null,
      editingDraft: { ...EMPTY_DRAFT },
    }));
  }

  handleCancelEditRule() {
    this.setState({ editingIndex: null, editingDraft: { ...EMPTY_DRAFT } });
  }

  handleSaveShoppingRules() {
    const payload = this.state.shoppingRules.map(({ product_id, warehouse_id, price_limitation, stock_limitation }) => ({
      product_id,
      warehouse_id,
      price_limitation,
      stock_limitation,
    }));

    this.settingDataService.add({ key: 'shopping_rules', value: JSON.stringify(payload) })
      .then(() => {
        this.setState({ successShoppingRules: true });
        setTimeout(() => {
          this.setState({ successShoppingRules: false });
        }, 5000);
      })
  }

  render() {
    return (
      <>
        <Header />
        {/* Page content */}
        <Container className="mt--7" fluid>
          <Row>
            <div className="col">
              <Card className="shadow mb-4">
                <CardHeader className="border-0">
                  <h3 className="mb-0">Kredit</h3>
                  <p className="text-sm text-muted mb-0">Batas maksimal kredit yang bisa diberikan ke pelanggan.</p>
                </CardHeader>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col lg="12">
                                {this.state.success && (
                                    <Alert color="success">
                                        Update berhasil.
                                    </Alert>
                                )}
                            </Col>
                            <Col lg="6">
                                <label
                                    className="form-control-label"
                                    htmlFor="input-barcode"
                                >
                                    Max Kredit
                                </label>
                                <InputGroup className="input-group-alternative">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                        <i className="ni ni-money-coins" />
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Max Kredit"
                                    name="maxCredit"
                                    value={this.state.maxCredit}
                                    onChange={this.handleInputChanged.bind(this)}
                                    onKeyUp={this.onKeyUp.bind(this)}
                                    type="text" />
                                </InputGroup>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup className="mb-0">
                        <div className="btn-wrapper text-right">
                        <Button
                            className="my-4"
                            color="primary"
                            type="button"
                            onClick={() => this.handleSaveMaxCredit()}
                            >
                            Simpan
                        </Button>
                        </div>
                    </FormGroup>
                </CardBody>
              </Card>
            </div>
          </Row>
          <Row>
            <div className="col">
              <Card className="shadow mb-4">
                <CardHeader className="border-0">
                  <h3 className="mb-0">Stok Produk</h3>
                  <p className="text-sm text-muted mb-0">Ambang batas stok minimal sebelum produk dianggap menipis.</p>
                </CardHeader>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col lg="12">
                                {this.state.successSettings && (
                                    <Alert color="success">
                                        Update berhasil.
                                    </Alert>
                                )}
                            </Col>
                            <Col lg="6">
                                <label
                                    className="form-control-label"
                                    htmlFor="input-barcode"
                                >
                                    Minimal Stok Produk
                                </label>
                                <InputGroup className="input-group-alternative">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                        <i className="ni ni-box-2" />
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Minimal Stok Produk"
                                    name="minProductStock"
                                    value={this.state.minProductStock?.value}
                                    onChange={this.handleInputChanged.bind(this)}
                                    onKeyUp={this.onKeyUp.bind(this)}
                                    type="text" />
                                </InputGroup>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup className="mb-0">
                        <div className="btn-wrapper text-right">
                        <Button
                            className="my-4"
                            color="primary"
                            type="button"
                            onClick={() => this.handleSaveSetting()}
                            >
                            Simpan
                        </Button>
                        </div>
                    </FormGroup>
                </CardBody>
              </Card>
            </div>
          </Row>
          <Row>
            <div className="col">
              <Card className="shadow mb-4">
                <CardHeader className="border-0">
                  <h3 className="mb-0">Konfigurasi Poin Loyalty</h3>
                  <p className="text-sm text-muted mb-0">Aturan perolehan poin dari transaksi pelanggan.</p>
                </CardHeader>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col lg="12">
                                {this.state.successLoyaltySettings && (
                                    <Alert color="success">
                                        Update berhasil.
                                    </Alert>
                                )}
                            </Col>
                            <Col lg="6">
                                <label
                                    className="form-control-label"
                                    htmlFor="input-points-per-star"
                                >
                                    Jumlah Poin untuk 1 Bintang
                                </label>
                                <InputGroup className="input-group-alternative">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                        <i className="fa-solid fa-star" />
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Jumlah Poin untuk 1 Bintang"
                                    name="pointsPerStar"
                                    value={this.state.pointsPerStar?.value}
                                    onChange={this.handleInputChanged.bind(this)}
                                    onKeyUp={this.onKeyUp.bind(this)}
                                    type="text" />
                                </InputGroup>
                            </Col>
                            <Col lg="6">
                                <label
                                    className="form-control-label"
                                    htmlFor="input-amount-per-point"
                                >
                                    Kelipatan Transaksi untuk 1 Poin (Rp)
                                </label>
                                <InputGroup className="input-group-alternative">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                        <i className="ni ni-money-coins" />
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Kelipatan Transaksi untuk 1 Poin"
                                    name="amountPerPoint"
                                    value={this.state.amountPerPoint?.value}
                                    onChange={this.handleInputChanged.bind(this)}
                                    onKeyUp={this.onKeyUp.bind(this)}
                                    type="text" />
                                </InputGroup>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup className="mb-0">
                        <div className="btn-wrapper text-right">
                        <Button
                            className="my-4"
                            color="primary"
                            type="button"
                            onClick={() => this.handleSaveLoyaltySetting()}
                            >
                            Simpan
                        </Button>
                        </div>
                    </FormGroup>
                </CardBody>
              </Card>
            </div>
          </Row>
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <h3 className="mb-0">Batas Belanja per Produk</h3>
                  <p className="text-sm text-muted mb-0">
                    Batasi harga dan/atau stok per produk yang boleh dibeli dalam sebulan, per warehouse. Kosongkan/isi 0 untuk tanpa batas.
                  </p>
                </CardHeader>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col lg="12">
                                {this.state.successShoppingRules && (
                                    <Alert color="success">
                                        Update berhasil.
                                    </Alert>
                                )}
                                {this.state.ruleErrorMessage && (
                                    <Alert color="danger">
                                        {this.state.ruleErrorMessage}
                                    </Alert>
                                )}
                            </Col>
                            <Col lg="4">
                                <label className="form-control-label" htmlFor="input-shopping-rule-product">
                                    Produk
                                </label>
                                <div className="position-relative">
                                    <InputGroup className="input-group-alternative">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                            <i className="ni ni-zoom-split-in" />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input name="productSearchType"
                                        type="select"
                                        className="mx-2 flex-grow-0"
                                        style={{ width: 130 }}
                                        value={this.state.productSearchType}
                                        onChange={this.handleProductSearchTypeChanged.bind(this)}>
                                            <option value="nama">Nama</option>
                                            <option value="barcode">Barcode</option>
                                        </Input>
                                        <Input placeholder={this.state.productSearchType === 'barcode' ? 'Cari barcode produk' : 'Cari nama produk'}
                                        id="input-shopping-rule-product"
                                        name="productKeyword"
                                        autoComplete="off"
                                        value={this.state.productKeyword}
                                        onChange={this.handleProductKeywordChanged.bind(this)}
                                        type="text" />
                                    </InputGroup>
                                    {this.state.productResults.length > 0 && (
                                        <div className="dropdown-menu show w-100 shadow" style={{ maxHeight: 220, overflowY: 'auto' }}>
                                            {this.state.productResults.map(product => (
                                                <button
                                                    key={product.product_id}
                                                    type="button"
                                                    className="dropdown-item"
                                                    onClick={() => this.handleSelectProduct(product)}
                                                >
                                                    {product.product_name}
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </Col>
                            <Col lg="2">
                                <label className="form-control-label" htmlFor="input-shopping-rule-warehouse">
                                    Warehouse
                                </label>
                                <Input placeholder="Warehouse"
                                id="input-shopping-rule-warehouse"
                                name="warehouse_id"
                                type="select"
                                value={this.state.newRule.warehouse_id}
                                onChange={this.handleNewRuleChanged.bind(this)}>
                                    <option value={-1}>Pilih warehouse</option>
                                    {this.state.warehouses.map(warehouse => (
                                        <option key={warehouse.warehouse_id} value={warehouse.warehouse_id}>
                                            {warehouse.warehouse_name}
                                        </option>
                                    ))}
                                </Input>
                            </Col>
                            <Col lg="3">
                                <label className="form-control-label" htmlFor="input-shopping-rule-price">
                                    Batas Harga (Rp)
                                </label>
                                <Input placeholder="0 = tanpa batas"
                                id="input-shopping-rule-price"
                                name="price_limitation"
                                value={this.state.newRule.price_limitation}
                                onChange={this.handleNewRuleChanged.bind(this)}
                                type="text" />
                            </Col>
                            <Col lg="3">
                                <label className="form-control-label" htmlFor="input-shopping-rule-stock">
                                    Batas Stok
                                </label>
                                <Input placeholder="0 = tanpa batas"
                                id="input-shopping-rule-stock"
                                name="stock_limitation"
                                value={this.state.newRule.stock_limitation}
                                onChange={this.handleNewRuleChanged.bind(this)}
                                type="text" />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <div className="btn-wrapper text-right">
                        <Button
                            color="primary"
                            outline
                            type="button"
                            onClick={this.handleAddRule.bind(this)}
                            >
                            Tambah Produk
                        </Button>
                        </div>
                    </FormGroup>
                    <ShoppingRules
                        rules={this.state.shoppingRules}
                        warehouses={this.state.warehouses}
                        onRemove={this.handleRemoveRule.bind(this)}
                        editingIndex={this.state.editingIndex}
                        editingDraft={this.state.editingDraft}
                        onEditStart={this.handleStartEditRule.bind(this)}
                        onEditChange={this.handleEditRuleChanged.bind(this)}
                        onEditSave={this.handleSaveEditRule.bind(this)}
                        onEditCancel={this.handleCancelEditRule.bind(this)}
                    />
                    <FormGroup className="mb-0 mt-3">
                        <div className="btn-wrapper text-right">
                        <Button
                            className="my-4"
                            color="primary"
                            type="button"
                            onClick={() => this.handleSaveShoppingRules()}
                            >
                            Simpan
                        </Button>
                        </div>
                    </FormGroup>
                </CardBody>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}

export default Settings;
